"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesImportPreview = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/sites/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
require("./sites-import-preview.less");
const core_1 = require("@material-ui/core");
let SitesImportPreview = class SitesImportPreview extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.getParsedFile = async () => {
            // if (sitesStore.importedFile && sitesStore.importedFile.accepted) {
            //   const accepted = sitesStore.importedFile.accepted;
            //   this.loadingSaving = true;
            //   await sitesStore.parse(accepted);
            //   this.loadingSaving = false;
            //   console.log("sitesStore.parsedSite is ", sitesStore.parsedSites);
            //   const sites = sitesStore.parsedSites.sites.slice(
            //     sitesStore.selectedRowIndex
            //   );
            //   const importedSites = sitesStore.importedSites;
            //   console.log("importedSites is ", toJS(importedSites));
            //   console.log("this.mappedHeadersObject is ", this.mappedHeadersObject);
            //   this.sitesToPersist = sites.map((site: any, index: number) => {
            //     const newSite: { [key: string]: string } = {};
            //     for (const key in site) {
            //       if (site[this.mappedHeadersObject[key]] !== undefined) {
            //         newSite[key] = site[this.mappedHeadersObject[key]];
            //       } else {
            //         newSite[key] = importedSites[index][this.mappedHeadersObject[key]];
            //       }
            //     }
            //     return newSite;
            //   });
            //   console.log("this.sitesToPersist is ", this.sitesToPersist);
            // }
            const importedOrders = store_1.sitesStore.importedSites;
            // console.log("importedOrders is ", importedOrders);
            this.sitesToPersist = importedOrders.map((order) => {
                const newSite = {};
                // @tkay
                store_1.sitesStore.dbHeaders.forEach(key => {
                    newSite[key] = this.mappedHeadersObject[key]
                        ? order[this.mappedHeadersObject[key]]
                        : "";
                });
                return newSite;
            });
        };
        this.handleOnConfirmation = () => {
            // console.log("handleOnConfirmation triggered");
            this.showConfirmationModal = true;
        };
        this.handleSubmitReview = () => {
            // console.log("handleSubmitReview triggered");
            this.showConfirmationModal = false;
            this.loadingSaving = true;
            store_1.sitesStore.submit(this.sitesToPersist).then(() => {
                this.loadingSaving = false;
                router_1.RouteManager.transitionTo("/pharmacies");
            });
        };
        this.handleOnCancel = () => {
            console.log("handleOnCancel triggered");
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        this.renderPreview = () => {
            // console.log("renderPreview triggered");
            const rowsArray = this.sitesToPersist.map((row) => {
                const data = [];
                for (const prop in row) {
                    if (row.hasOwnProperty(prop)) {
                        data.push(row[prop]);
                    }
                }
                return data;
            });
            // prepend header
            const headers = [];
            for (const prop in this.sitesToPersist[0]) {
                if (this.sitesToPersist[0].hasOwnProperty(prop)) {
                    headers.push(prop);
                }
            }
            rowsArray.unshift(headers);
            return rowsArray.map((row, i) => this.renderTableRow(row, i));
        };
    }
    componentWillReceiveProps() {
        console.log("cwrp triggered");
    }
    componentWillMount() {
        // console.log("cdm triggered");
        this.mappedHeadersObject = store_1.sitesStore.mappedHeadersObject || {};
        this.getParsedFile();
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement("div", { className: "header-paper--select" },
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please review the data"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/pharmacies/import/map" }, "Back"),
                            React.createElement(button_1.MaterialButton, { disabled: this.loadingSaving, primary: true, onClick: this.handleOnConfirmation }, "confirm"))),
                    this.sitesToPersist && (React.createElement(core_1.Table, { className: "select-header-table" },
                        React.createElement(core_1.TableBody, null, this.sitesToPersist && this.renderPreview()))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container--select__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container--select__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", message: `Please review the mapped table. If you are satisfied with the mapping, please submit.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: this.handleSubmitReview, title: "Review confirmation" }))));
    }
};
__decorate([
    mobx_1.observable
], SitesImportPreview.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], SitesImportPreview.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], SitesImportPreview.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], SitesImportPreview.prototype, "sitesToPersist", void 0);
SitesImportPreview = __decorate([
    mobx_react_1.observer
], SitesImportPreview);
exports.SitesImportPreview = SitesImportPreview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-import-preview/sites-import-preview.tsx
// module id = 4084
// module chunks = 0